import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useOperacaoDropdownList(filters: any) {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_OPERACAO_DROPDOWN_ID_EXTERNO, filters],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_OPERACAO_DROPDOWN_ID_EXTERNO, {
        params: filters,
      });
      
      return data;
    },
    {
      keepPreviousData: true,
      enabled: !!filters?.OperacaoClasseIdExterno,
    }
  );
}

export default useOperacaoDropdownList;